module.exports = __webpack_public_path__ + "img/burn-icon.9e0c4742.svg";